import React, { Fragment } from 'react';
import blank from 'components/assets/img/pic/blank/dashboard.svg';
import { connect } from 'react-redux';
import T from 'components/common/translations/Translate';

class NotFound extends React.Component {

  render() {
    return (
      <div className="content content--not-found">
        <div className="not-found-wrap">
          <div className="not-found">
            <img src={blank} alt="" className="mb-30" />
            <h1><T>errors.notFound.title</T></h1>
            <p style={{ margin: '0 0 50px' }}>
              <T>errors.notFound.content</T>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    isLogged: state.app.isLogged,
  }
}

export default connect(mapStateToProps)(NotFound);
